@if (formGroupVenue) {
  <fhm-page [title]="title" [showSave]="model.draft"
    [saveLabel]="smallScreen ? 'fhm.common.button.save' :  'fhm.common.button.draft'"
    [showComplete]="model.draft"
    [showDone]="!model.newVenue"
    (doneClicked)="done()"
    (saveClicked)="saveAsDraft()"
    (completeClicked)="complete()"
    [completeLabel]="'fhm.common.button.signUp'"
    [description]="'fhm.customer-instance-venue.description' | translate">
    @if (this.model.data.venue && formGroupVenue) {
      <fui-rows [formGroup]="formGroupVenue">
        @if (this.model.data.venue.discontinued) {
          <fui-row>
            <fui-two-columns>
              <fui-column>
                <fui-inline-information
                  [title]="'fhm.customer-instance-venue.messages.venueDiscontinued.title'"
                  [message]="'fhm.customer-instance-venue.messages.venueDiscontinued.message'"
                ></fui-inline-information>
              </fui-column>
            </fui-two-columns>
          </fui-row>
        }
        @if (this.model.data.venue.deploymentStatus === CustomerInstanceVenueData.DEPLOYMENT_STATUS_CHURNED) {
          <fui-row>
            <fui-two-columns>
              <fui-column>
                <fui-inline-information
                  [title]="'fhm.customer-instance-venue.messages.venueChurned.title'"
                  [message]="'fhm.customer-instance-venue.messages.venueChurned.message'"
                ></fui-inline-information>
              </fui-column>
            </fui-two-columns>
          </fui-row>
        }
        <fui-row>
          <fhm-signup-status [loggedUser]="loggedUser"
            (sendSignUpUrlClicked)="sendSignUpUrl()"
            (signInPersonClicked)="signInPerson()"
            (openCustomerPortalClicked)="openCustomerPortal()"
            (openAppPaymentAccountClicked)="openAppPaymentAccount()"
            (getSignUpUrlClicked)="getSignUpUrl()"
            (getSetupAppPaymentAccountUrlClicked)="getSetupAppPaymentAccountUrl()"
            (discontinueClicked)="discontinueVenue()"
            (recontinueClicked)="recontinueVenue()">
          </fhm-signup-status>
        </fui-row>
        <fui-row [label]="'Venue'">
          <fui-content-layout-header-control slot="after">
            @if (!editingVenue && model.canEdit(true)) {
              <fui-link-button [title]="'edit'"
              (click)="edit()"></fui-link-button>
            }
          </fui-content-layout-header-control>
          <fui-column>
            <fui-rows>
              <fui-row>
                <fui-two-columns>
                  <fui-column>
                    <fui-text-control formControlName="name"
                      [control]="formGroupVenue.get('name')"
                      [label]="'fhm.customer-instance-venue.name.label'"
                      [placeholder]="'fhm.customer-instance-venue.name.placeholder'"
                      [disabled]="!editingVenue"
                    [(ngModel)]="model.data.venue.name"></fui-text-control>
                  </fui-column>
                  <fui-column [formGroup]="formGroupVenue">
                    <fui-text-control [label]="'fhm.customer-instance-venue.venueId.label'"
                      [placeholder]="'fhm.customer-instance-venue.venueId.placeholder'"
                      [disabled]="true"
                      [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="model.data.venue.id"></fui-text-control>
                  </fui-column>
                </fui-two-columns>
              </fui-row>
              <fui-row>
                <fui-two-columns>
                  <fui-column>
                    @if (!UserData.isSalesRep(loggedUser)) {
                      <fhm-user-select-control
                        [disabled]="!editingVenue"
                        [(value)]="model.data.venue.salesRep"
                        [required]="true"
                        [label]="'fhm.customer-instance-venue.salesRep.label'">
                      </fhm-user-select-control>
                    }
                    @if (UserData.isSalesRep(loggedUser)) {
                      <fui-text-control
                        [disabled]="true"
                        [value]="model.data.venue.salesRep"
                        [label]="'fhm.customer-instance-venue.salesRep.label'">
                      </fui-text-control>
                    }
                  </fui-column>
                  <fui-column>
                    @if (!UserData.isSalesRep(loggedUser)) {
                      <fhm-partner-select-control
                        [disabled]="!editingVenue"
                        [(value)]="model.data.venue.partner"
                        [required]="false"
                        [label]="'Partner'">
                      </fhm-partner-select-control>
                    }
                  </fui-column>
                </fui-two-columns>
              </fui-row>
              <fui-row>
                <fui-two-columns>
                  <fui-column>
                    @if (model.data.groupId) {
                      <fui-text-control
                        [disabled]="true"
                        [value]="model.data.groupId"
                        [label]="'Group'">
                      </fui-text-control>
                    }
                  </fui-column>
                  <fui-column>
                    @if (model.data.instance && !editingVenue) {
                      <fui-select-control
                        [options]="[model.data.instance]"
                        [(value)]="model.data.instance"
                        [disabled]="true"
                        [labelField]="'clientId'"
                        [label]="'fhm.customer-instance-venue.instanceId.label'"
                        [loading]="false"
                        [placeholder]="' '"
                        [valueField]="'id'"
                        (optionOpened$)="goToInstance()"
                        [removable]="false"
                        [showAddOption]="false">
                      </fui-select-control>
                    }
                    @if (model.data.instance && editingVenue) {
                      <fui-tandem-field>
                        <fui-select-control [options]="[model.data.instance]"
                          [(value)]="model.data.instance"
                          [disabled]="true"
                          [labelField]="'clientId'"
                          [label]="'fhm.customer-instance-venue.instanceId.label'"
                          [loading]="false"
                          [placeholder]="' '"
                          [valueField]="'id'"
                          (optionOpened$)="goToInstance()"
                          [showOptionOpenOption]="!UserData.isSalesRep(loggedUser)"
                          [removable]="false"
                          [showAddOption]="false">
                        </fui-select-control>
                        @if (!UserData.isSalesRep(loggedUser)) {
                          <fhm-provision-button [title]="'Reassign'"
                          (clicked)="assignInstance()"></fhm-provision-button>
                        }
                      </fui-tandem-field>
                    }
                    @if (!UserData.isSalesRep(loggedUser) && !model.data.instance && model.data.venue.deploymentStatus === CustomerInstanceVenueData.DEPLOYMENT_STATUS_READY) {
                      <fhm-provision-button [title]="'Assign Instance'"
                      (clicked)="assignInstance()"></fhm-provision-button>
                    }
                  </fui-column>
                </fui-two-columns>
              </fui-row>
            </fui-rows>
            @if (editingVenue && !model.draft) {
              <fhm-action-buttons>
                <fhm-remove-button [title]="'fhm.common.button.cancel'"
                (clicked)="cancelEdit()"></fhm-remove-button>
                <fhm-provision-button [title]="'fhm.common.button.save'"
                (clicked)="saveVenue()"></fhm-provision-button>
              </fhm-action-buttons>
            }
          </fui-column>
        </fui-row>
        <fui-row>
          <fhm-venue-company [formGroupCompany]="formGroupCompany"></fhm-venue-company>
        </fui-row>
        <fui-row>
          <fhm-venue-address [formGroupAddress]="formGroupAddress"></fhm-venue-address>
        </fui-row>
        <fui-row>
          <fhm-venue-contact [formGroupContact]="formGroupPrimaryContact" [label]="'Primary Contact'"
          [contactId]="VenueContactData.PRIMARY_CONTACT_ID"></fhm-venue-contact>
        </fui-row>
        <fui-row>
          <fhm-venue-services [formGroupServices]="formGroupServices"
          [allowStoreLimit]="!UserData.isSalesRep(loggedUser)"></fhm-venue-services>
        </fui-row>
        <fui-row>
          <fhm-venue-plan [formGroupPlan]="formGroupPlan" [loggedUser]="loggedUser"></fhm-venue-plan>
        </fui-row>
        <fui-row>
          <fhm-venue-plan-management [loggedUser]="loggedUser"></fhm-venue-plan-management>
        </fui-row>
        @if (UserData.isAdmin(loggedUser) && model.data.venue.deploymentStatus === CustomerInstanceVenueData.DEPLOYMENT_STATUS_READY) {
          <fui-row
            >
            <fhm-venue-card-verification></fhm-venue-card-verification>
          </fui-row>
        }
        @if (model.data.venue.id) {
          <fui-row>
            <fhm-menu [loggedUser]="loggedUser"></fhm-menu>
          </fui-row>
        }
        @if (model.data.buildTask) {
          <fui-row [label]="'ClickUp Tasks'">
            <fui-two-columns>
              <fui-column>
                <fui-select-control
                  [options]="[model.data.buildTask]"
                  [value]="model.data.buildTask"
                  [disabled]="true"
                  [labelField]="'clickUpId'"
                  [label]="'Build Task'"
                  [loading]="false"
                  [placeholder]="' '"
                  [valueField]="'clickUpId'"
                  (optionOpened$)="openClickUp()"
                  [showOptionOpenOption]="true"
                  [removable]="false"
                  [showAddOption]="false">
                </fui-select-control>
              </fui-column>
            </fui-two-columns>
          </fui-row>
        }
        <fui-row>
          <fhm-sales-handover [formGroupContact]="formGroupSiteContact"></fhm-sales-handover>
        </fui-row>
      </fui-rows>
    }
  </fhm-page>
}
